export default __webpack_public_path__ + "static/media/backgroundPlayer.2ddaa50b.png";